var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticStyle:{"margin-bottom":"1.5%"},attrs:{"id":'casetype_'+_vm.appointmentId,"reduce":s => s.id,"label":"name","options":_vm.caseTypeList},model:{value:(_vm.selectedCaseType),callback:function ($$v) {_vm.selectedCaseType=$$v},expression:"selectedCaseType"}})
}
var staticRenderFns = []

export { render, staticRenderFns }